import {  useState,useContext } from "react";
import { GlobalProvider } from "../Context/GlobalState";
import { GlobalContext } from "../Context/GlobalState";
import { useNavigate } from "react-router-dom";


import axios from "axios";

export default function MunavebeKayit() {

  const navigate = useNavigate();
  const {isLogin, API_URL, avukatlar, setAvukatlar
     } = useContext(GlobalContext);


  const kullaniciAdi = window.localStorage.getItem("user");
  const [avukatAdi, setAvukatAdi] = useState("");

  const avukatiDbyeKaydet = (e) => {
    e.preventDefault();

    axios
      .post(API_URL + "/avukatkaydet", {
        kullaniciAdi,
        avukatAdi,
      })
      .then((response) => {
        alert(response.data);
        //window.location.reload();
      })
      .catch((error) => {
        alert("Bir hata Oluştu!");
        console.error("There was an error!", error);
      });
  };

    const avukatSil = async (id) => {
      if (!window.confirm("Bu Avukat silinsin mi?")) return;

      try {
        await axios.delete(`${API_URL}/avukat/${id}`);

        setAvukatlar((prev) => prev.filter((item) => item.id !== id));

        alert("Avukat silindi.");
      } catch (err) {
        console.log(err.data);
        alert("Silinemedi.");
      }
    };

  return (
    <GlobalProvider>
      {isLogin ? (
        <div className="container">
          <div className="row">
            <h1 className="text-center">Avukat Kayıt </h1>
          </div>

          <form onSubmit={avukatiDbyeKaydet}>
            <div className="row justify-content-center">
              <div className="col-4 mt-5 mb-2 mx-2">
                <input
                  type="text"
                  name="avukatAdi"
                  id="avukatAdi"
                  placeholder="Av. AvukatAdı AvukatSoyadı"
                  className="form-control"
                  onChange={(e) => setAvukatAdi(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="row">
              <div className="col"></div>
              <div className="col"></div>
              <div className="col"></div>
              <div className="col">
                <button type="submit" className="btn btn-primary btn-lg mt-5">
                  Avukatı Kaydet
                </button>
              </div>
            </div>
          </form>

          <hr className="my-5" />

          <h3>Kayıtlı Avukatlar</h3>

          <table className="table table-striped table-hover">
            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>Avukat Adı</th>
                <th>İşlem</th>
              </tr>
            </thead>

            <tbody>
              {avukatlar.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.name}</td>

                  <td width="120">
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => avukatSil(item.id)}
                    >
                      Sil
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        navigate("/")
      )}
    </GlobalProvider>
  );
}
